module.exports = __webpack_public_path__ + "img/ad3x.7c433406.png";